const development = {
  addin: 'https://localhost:3000',
  backend: 'http://localhost:3001',
  website: 'http://localhost:3002',
};

const production = {
  addin: 'https://addin.xl-master.com',
  backend: 'https://api.xl-master.com',
  website: 'https://xl-master.com',
};

module.exports = {
  development,
  production,
};

